import { configPromise } from "../../config/configMiddleware";
import { cleanData, deleteWith, getWith, patchWith, postWith, updateWith } from "../axios";

export async function GetOrgBrands(orgID: string | undefined): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/brand/get-org-brands/${orgID}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetBrandMarketPreference(
  brandID: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/brand/brand-preferences/${brandID}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function CreatePartnerRequest(data: {
  brand_id: any;
  engagement_model_id: any;
  country_id: number;
  status: string;
  services: any;
}) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/discovery/create-brand-request/`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetBrandRequests(
  brandID: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/discovery/fetch-brand-request/${brandID}`;

    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetBrandRequestsByID(
  id: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/discovery/fetch-brand-id/${id}`;

    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetBrandRequestsForOrg(brands: { brand_ids: any[] }) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/discovery/fetch-request-for-org`;
    return (await postWith<any, any>(url, brands)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

// export async function GetAllBrandRequests() {
//   try {
//     const url = `${config.REACT_APP_API_URL}v1/advisory/all-report-request/1`;
//     return (await getWith<any[]>(url)) as any;
//   } catch (ex: any) {
//     throw ex.response.data;
//   }
// }

export async function GetAllBrandRequests(
  listpage?: any,
  searchParam?: string
) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL
      }v1/discovery/fetch-all-brand-requests/${listpage ? listpage + 1 : 1
      }/${searchParam}`;
    console.log(url);
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetBrandRequestsDataRestriction(
  user_id: string | undefined,
  listpage?: any,
  searchParam?: string
) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL
      }v1/role/discovery-req-data-restriction/${user_id}/${listpage ? listpage + 1 : 1
      }/${searchParam ? searchParam : ""}`;
    console.log(url);
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetBrandDocuments(
  brandID: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/document/1/${brandID}`;
    // console.log(url);
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetReqForPartner(
  servicesProvided: { service_id: number; country_id: number }[],
  partnerID: string | undefined,
  listPage?: number,
  searchParam?: string
) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL
      }v1/discovery/fetch-request-for-partner/${listPage ? listPage + 1 : 1}/${searchParam ? searchParam : ""
      }`;
    const param: any = { services: servicesProvided, partner_id: partnerID };
    console.log(url, param);
    return (await postWith<any, any>(url, param)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function ExpressPartnerInterest(data: any) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/discovery/create-partner-interest`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function expressInterestByPartner(data: any) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/discovery/create-partner-interest`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetInterestForBrand(id: string | undefined) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/discovery/fetch-interest-for-brand/${id}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetAllServices() {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/common/fetch-services`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function AcceptPartnerInterest(data: any) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/discovery/accept-partner-interest`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function RecommendPartnerInterest(id: string, data: any) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/discovery/update-partner-recommendation/${id}`;
    return (await patchWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetSuitablePartners(id: any, listpage?: number) {
  const data = {
    id: id,
  };
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL
      }v1/discovery/fetch-suitable-partners/${listpage ? listpage : 1}`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getInterestedPartners(
  id: string | undefined,
  listpage?: number
) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL
      }v1/discovery/fetch-interest-for-brand/${id}/${listpage ? listpage : 1}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getRecommendedPartners(
  id: string | undefined,
  listpage?: number
) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL
      }v1/discovery/fetch-recommended/${id}/${listpage ? listpage : 1}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getAcceptedPartners(
  id: string | undefined,
  listpage?: number
) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/discovery/fetch-accepted/${id}/${listpage ? listpage : 1
      }`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

// export async function deleteBrandRequest(id: string): Promise<any> {
//   try {
//     const config = await configPromise;
//     const url = `${config.REACT_APP_API_URL}v1/discovery/hard-delete/${id}`;
//     return (await deleteWith<any, any>(url, {})) as any;
//   } catch (ex: any) {
//     throw ex.response.data;
//   }
// }

export async function softDeleteBrandRequest(id: string): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/discovery/soft-delete/${id}`;
    return (await deleteWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function restoreBrandRequest(
  id: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/discovery/restore/${id}`;
    return (await updateWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getBrandRequestByID(
  id: string | undefined,
  fileSettingsId?: number | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    let url = `${config.REACT_APP_API_URL}v1/discovery/fetch-brand-request-by-id/${id}`;
    if (fileSettingsId) {
      url = `${url}/${fileSettingsId}`;
    }
    console.log("url", url);

    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getDiscoveryPartnerByID(
  id: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/discovery/fetch-discovery-partner/${id}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getDiscoveryMarketByPartner(data: any): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/marketV2/fetch-by-country/${data?.partner_id}/${data?.country}`;
    return (await getWith<any>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}


export async function createBrandRequest(req: any) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/discovery-request-v2`;
    return (await postWith<any, any>(url, req)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getBrandRequestsByOrgId(
  orgId: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/discovery-request-v2${orgId ? `?orgId=${orgId}` : ""}`;

    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getBrandRequests(
  pageNumber: number,
  pageSize: number,
  orgId?: string | undefined,
  partnerId?: string | undefined,
  status?: string[],
  category?: string[],
  seachKey?: string,
  sort?: string,
  sortBy?: string
): Promise<any> {
  try {


    const req = {
      status: status && status?.length > 0 ? status : undefined,
      category: category && category?.length > 0 ? category : undefined,
    };
    const where = cleanData(req)

    let sorter = sortBy;
    if (sortBy && ["interested_count", "suitable_count", "recommended_count"].includes(sortBy)) {
      sorter = `counts.${sortBy}`
    }

    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/discovery-request-v2/?page=${pageNumber}&size=${pageSize}${orgId ? `&orgId=${orgId}` : ""}${partnerId ? `&partnerId=${partnerId}` : ""}${seachKey ? `&searchterm=${seachKey}` : ""}${sort ? `&sort=${sort}` : ""}${sortBy ? `&sortBy=${sorter}` : ""}&where=${encodeURIComponent(JSON.stringify(where))}`;

    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getSuitableBrandRequests(
  partnerId?: string | undefined,
  status?: string[],
  category?: string[],
  seachKey?: string,
  sort?: string,
  sortBy?: string
): Promise<any> {
  try {

    const req = {
      category: category && category?.length > 0 ? category : undefined,
    };
    const where = cleanData(req)

    const brandStatus = status && status?.length > 0 ? JSON.stringify(status) : undefined

    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/discovery-request-v2/fetch-suitable-brand-requests/${partnerId}?${seachKey ? `&searchterm=${seachKey}` : ""}${sort ? `&sort=${sort}` : ""}${sortBy ? `&sortBy=${sortBy}` : ""}${brandStatus ? `&brandStatus=${brandStatus}` : ""}&where=${encodeURIComponent(JSON.stringify(where))}`;

    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getBrandRequestsPartnersByRequestId(
  id: string,
  status: string[]
): Promise<any> {
  try {

    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/discovery-brand-partners-v2/discovery-request/${id}${status?.length > 0 ? `?status=${status?.join(",")}` : ""}`;

    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getSuitablePartnersByRequestId(
  id: string,
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/discovery-request-v2/fetch-suitable-partners/${id}`;

    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function updateBrandRequest(
  id: string | undefined,
  req: any
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/discovery-request-v2/${id}`;
    return (await updateWith<any, any>(url, req)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function updateBrandRequestPartner(
  id: string | undefined,
  req: any
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/discovery-brand-partners-v2/${id}`;
    return (await updateWith<any, any>(url, req)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}


export async function deleteBrandRequest(id: string): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/discovery-request-v2/${id}`;
    return (await deleteWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getBrandRequestDetails(
  id: string | undefined,
  partnerId?: string
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/discovery-request-v2/${id}${partnerId ? `?partnerId=${partnerId}` : ""}`;

    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getBrandRequestDocsByRequestId(
  id: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/discovery-documents-v2/?discovery_request_id=${id}`;

    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function updateDiscoveryDoc(
  id: string | undefined,
  req: any
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/discovery-documents-v2/${id}`;
    return (await updateWith<any, any>(url, req)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function addDiscoveryDoc(
  req: any
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/discovery-documents-v2`;
    return (await postWith<any, any>(url, req)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function uploadDiscoveryDoc(
  id: string,
  req: any
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/discovery-documents-v2/uploadfile/${id}`;
    return (await postWith<any, any>(url, req)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function deleteDiscoveryDoc(id: string): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/discovery-documents-v2/${id}`;
    return (await deleteWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function createBrandRequestPartner(req: any) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/discovery-brand-partners-v2`;
    return (await postWith<any, any>(url, req)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getMessages(
  discovery_request_id: string,
  partner_id: string,
): Promise<any> {
  try {
    const where = {
      partner_id: partner_id,
      discovery_request_id: discovery_request_id
    }
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/discovery-messages-v2?where=${JSON.stringify(where)}`;

    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getMessageDeliveryInfo(
  message_id: string
): Promise<any> {
  try {
    const where = {
      message_id: message_id
    }
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/discovery-message-deliveries-v2?where=${JSON.stringify(where)}`;

    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}



export async function sendSkipFeedback(req: any) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/email/send/skip-brand-notification`;
    return (await postWith<any, any>(url, req)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}